import React, { FunctionComponent } from 'react';

type Props = {
  isOpen: boolean;
  scoutMessageLinked: string;
  onClose: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  isOpen,
  scoutMessageLinked,
  onClose,
}) => {
  const modalClassName = `recruitment__show__scout-message-modal ${isOpen ? 'open' : ''}`;
  const overlayClassName = `recruitment__show__scout-message-modal__overlay ${isOpen ? 'open' : ''}`;

  return (
    <>
      <div className={modalClassName}>
        <div className="recruitment__show__scout-message-modal__wrapper">
          <div className="recruitment__show__scout-message-modal__header">
            <button className="close" onClick={onClose}>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.735395 12L0 11.2646L5.26461 6L0 0.735394L0.735395 0L6 5.26461L11.2646 0L12 0.735394L6.7354 6L12 11.2646L11.2646 12L6 6.73539L0.735395 12Z"
                  fill="#19190F"
                />
              </svg>
            </button>
            <h3 className="title">スカウト本文</h3>
          </div>
          <div
            className="recruitment__show__scout-message-modal__content"
            dangerouslySetInnerHTML={{ __html: scoutMessageLinked }}
          />
        </div>
      </div>
      <div onClick={onClose} className={overlayClassName}></div>
    </>
  );
};
